import React from 'react';
import { inject, observer } from 'mobx-react';
import H5CommonPopup from './h5';
import PCCommonPopup from './pc';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';

interface CommonSharePopupProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    // 是否显示
    visible: boolean;
    // 显示隐藏
    shareClose?: Function
    // 标题
    title?: string;
    // 取消事件
    onCancelChange?: Function
    // 取消按钮文字
    cancelText?: string
    // 插槽相关属性
    children?: React.ReactNode; // 内容插槽
    mode?: any  // 模式（黑色或白色,默认白色）
    copyText?: any  // 要复制的文本
    copyLink?: Function // 复制链接方法
    onDrawCanvas?: Function // 保存图片方法
    isShowCopy?: any    // 是否显示复制链接
    isShowSavePoster?: any    // 是否显示保存图片
    copyToastText?: any
}

@inject('app', 'site', 'user')
@observer
class CommonSharePopup extends React.Component<CommonSharePopupProps> {
    componentDidMount() {
        // 可以在这里添加初始化逻辑
        // console.log('组件组件');
    }

    render() {
        const { site, app, ...props } = this.props;
        const platform = app?.platform || 'h5';
        if (platform === 'pc') {
            return <PCCommonPopup {...props} />;
        } else {
            return <H5CommonPopup {...props} />;
        }
        
        
    }
}

export default CommonSharePopup;